module.exports = require("./zh-Hans-CN");